import React from 'react';
import { BanIcon, GraduationCapIcon, HandshakeIcon, MapPinIcon, SproutIcon, UsersIcon } from 'lucide-react';
import { benefits } from '../data/benefits';
import type { BenefitIcon, Sport } from '../types/landing';
import { fillTemplate, type TemplateTokens } from '../utils/template';
import { ContentNote } from './ContentNote';
const icons: Record<BenefitIcon, typeof BanIcon> = {
  sprout: SproutIcon,
  school: GraduationCapIcon,
  users: UsersIcon,
  handshake: HandshakeIcon,
  mapPin: MapPinIcon,
  ban: BanIcon
};
export function WhyPlay({
  sport,
  tokens,
  onCta
}: {
  sport: Sport;
  tokens: TemplateTokens;
  onCta: () => void;
}) {
  return <section aria-labelledby="why-play" className="relative border-t border-brand-line px-5 py-12 md:px-10 md:py-16" data-id="element-239" data-mp="2u05xl78ak4yj">
      <div className="grid gap-10 lg:grid-cols-12" data-id="element-240" data-mp="2l1kixn5xxa31">
        <div className="lg:col-span-4" data-id="element-241" data-mp="2l094mtevcjxo">
          <h2 id="why-play" className="font-display text-[34px] font-bold uppercase leading-[0.95] text-brand-navy md:text-[42px]" data-id="element-242" data-mp="2l3dea6b3s7vq">
            Why play {sport.noun} with i9 Sports®?
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-brand-ink" data-id="element-243" data-mp="3lehxlih1a9nk">
            We are the recreational alternative to club and travel teams: a fun first experience that builds skills and confidence.
          </p>
          <p className="mt-6 border-l-4 border-brand-red pl-4 font-display text-2xl font-semibold italic leading-tight text-brand-navy" data-id="element-244" data-mp="3ggyk4ks5u0wo">
            Everyone plays — every game.
          </p>
          <button type="button" onClick={onCta} className="mt-8 rounded-sm bg-brand-red px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-brand-redDark" data-id="element-245" data-mp="d0j7uyknnkii">
            Find {sport.name} Programs
          </button>
        </div>
        <ul className="grid gap-x-10 sm:grid-cols-2 lg:col-span-8" data-id="element-246" data-mp="2jr8szpizo186">
          {benefits.map(b => {
          const Icon = icons[b.icon];
          return <li key={b.icon} className="flex gap-4 border-t border-brand-line py-5" data-id="element-247" data-mp="2onza8g6j52v6">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-sky/10 text-brand-sky" data-id="element-248" data-mp="u925fwkvwhqe">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-249" data-mp="kk0rebxwgaf2" />
                </span>
                <div data-id="element-250" data-mp="kho2tfxmz1t1">
                  <h3 className="font-display text-xl font-bold uppercase leading-tight text-brand-navy" data-id="element-251" data-mp="gip267ixtr7e">{fillTemplate(b.title, tokens)}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-brand-muted" data-id="element-252" data-mp="bkx8b7yqfv0k">{fillTemplate(b.body, tokens)}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
      <ContentNote kind="wp" detail="Shared sport-level block, reused in every city." data-id="element-253" data-mp="1lohgnz5ywif" />
    </section>;
}